import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';
import Sidebar from '../../components/Sidebar/sidebar';
import Header from '../../components/Header';
import './AddPOS.css';
import { API_BASE_URL } from '../../utils/apiBase';
import axios from 'axios'; // Import axios

const POS = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [formData, setFormData] = useState({
        posName: '',
        posPhoneNumber: '',
        posEmail: '',
        posAddress: '',
        posPinCode: '',
        posCity: '',
        posState: '',
        posProfile: '',
    });

    if (!isAuthenticated()) {
        return <Navigate to="/" />;
    }

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'posProfile') {
            setFormData({ ...formData, [name]: files[0] }); // Save the selected file
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = new FormData();
            for (let key in formData) {
                submitData.append(key, formData[key]);
            }
    
            const response = await axios.post(`${API_BASE_URL}/api/pos/addPos`, submitData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            console.log('Data submitted:', response.data);
            setFormData({
                posName: '',
                posPhoneNumber: '',
                posEmail: '',
                posAddress: '',
                posPinCode: '',
                posCity: '',
                posState: '',
                posProfile: '',
            });
            alert('Data submitted successfully!');
        } catch (error) {
            console.error('Error submitting data:', error);
            alert('Error submitting data. Please try again.');
        }
    };
    


    return (
        <div className='POS-container'>
            <div className='sidebar'>
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            </div>
            <div className={`POS-content ${collapsed ? 'collapsed' : ''}`}>
                <Header />
                <section>
                    <form onSubmit={handleSubmit} className="POS-form">
                        <label>POS Name:</label>
                        <input type="text" name="posName" value={formData.posName} onChange={handleChange} />

                        <label>Phone Number:</label>
                        <input type="number" name="posPhoneNumber" value={formData.posPhoneNumber} onChange={handleChange} />

                        <label>Email:</label>
                        <input type="email" name="posEmail" value={formData.posEmail} onChange={handleChange} />

                        <label>Address:</label>
                        <input type="text" name="posAddress" value={formData.posAddress} onChange={handleChange} />

                        <label>City</label>
                        <textarea name="posCity" value={formData.posCity} onChange={handleChange} />

                        <label>State</label>
                        <input type="text" name="posState" value={formData.posState} onChange={handleChange} />

                        <label>Pin Code</label>
                        <input type="text" name="posPinCode" value={formData.posPinCode} onChange={handleChange} />

                        <label>Add Profile Pic</label>
                        <input type="file" accept="image/*" capture="user" name="posProfile" onChange={handleChange}
                        />



                        <button type="submit">Submit</button>
                    </form>
                </section>
            </div>
        </div>
    );
};

export default POS;